import Route from "./routing/Router";

import Login from "./views/pages/Auth/Login";
import Logout from "./views/pages/Auth/Logout";
import Register from "./views/pages/Auth/Register";
import VerifyAccount from "./views/pages/Auth/VerifyAccount";
import ForgotPassword from "./views/pages/Auth/ForgotPassword";
import ResetPassword from "./views/pages/Auth/ResetPassword";

/* ------------------ Site ---------------- */
import HomePage from "./views/pages/Site/HomePage";
import AboutPage from "./views/pages/Site/AboutPage";
import ContactPage from "./views/pages/Site/ContactPage";
import Search from "./views/pages/Site/Search";
import Tool from "./views/pages/Site/Tool";

/* ------------------ End Site ---------------- */

/* ------------------ Dashboard ---------------- */
import DashboardHome from "./views/pages/Dashboard/Home";
import DashboardAdminSettings from "./views/pages/Dashboard/Admin/Settings";

import DashboardIndustries from "./views/pages/Dashboard/Industry/AllIndustries";
import DashboardAddIndustry from "./views/pages/Dashboard/Industry/AddIndustry";
import DashboardEditIndustry from "./views/pages/Dashboard/Industry/EditIndustry";

import DashboardTools from "./views/pages/Dashboard/Tool/AllTool";
import DashboardAddTool from "./views/pages/Dashboard/Tool/AddTool";
import DashboardEditTool from "./views/pages/Dashboard/Tool/EditTool";

import DashboardEditAbout from "./views/pages/Dashboard/About/EditAbout";
import DashboardEditContact from "./views/pages/Dashboard/Contact/EditContact";

import DashboardUsers from "./views/pages/Dashboard/Users/AllUsers"
/* ------------------ End Dashboard ---------------- */

import NotFound from "./views/pages/NotFound";
import LayoutDashboard from "./views/layout/Dashboard";
import LayoutMaster from "./views/layout/Master";


/* --------------------  account  --------------------- */
Route.group("/account", () => {
    Route.add("account_login", {
        path: "/login",
        component: Login,
        //layout: AuthLayout
        layout: LayoutMaster
    });

    Route.add("account_logout", {
        path: "/logout",
        component: Logout,
        //layout: AuthLayout
    });

    Route.add("account_register", {
        path: "/register",
        component: Register,
        //layout: AuthLayout
        //layout:LayoutMaster
    });

    Route.add("account_verify_account", {
        path: "/verify-account/:token",
        component: VerifyAccount,
        //layout: AuthLayout
        //layout:LayoutMaster
    });

    Route.add("account_forgot", {
        path: "/forgot-password",
        component: ForgotPassword,
        //layout: AuthLayout
    });
    
    Route.add("account_reset", {
        path: "/reset-password/:forgot_token",
        component: ResetPassword,
        //layout: AuthLayout
    });
});


/* --------------------  dashboard  --------------------- */
Route.group("/dashboard", () => {
    Route.redirectRoute("/", "dashboard_home");

    Route.add("dashboard_home", {
        path: "/home",
        component: DashboardHome,
        //layout: LayoutDashboard,dashboard_about_edit
        auth: true,
        role: "admin",
    });

    Route.group("/abouts", () => {
        Route.add("dashboard_about_edit", {
            path: "/edit",
            component: DashboardEditAbout,
            //layout: LayoutDashboard,
            auth: true,
            role: "admin",
        });
    });

    Route.group("/contacts", () => {
        Route.add("dashboard_contact_edit", {
            path: "/edit",
            component: DashboardEditContact,
            //layout: LayoutDashboard,
            auth: true,
            role: "admin",
        });
    });

    Route.group("/industries", () => {
        Route.add("dashboard_industry_all", {
            path: "/all",
            component: DashboardIndustries,
            //layout: LayoutDashboard,
            auth: true,
            role: "admin",
        });
        Route.add("dashboard_industry_add", {
            path: "/add-new",
            component: DashboardAddIndustry,
            //layout: LayoutDashboard,
            auth: true,
            role: "admin",
        });
        Route.group("/:industryId", () => {
            Route.add("dashboard_industry_edit", {
                path: "/edit",
                component: DashboardEditIndustry,
                //layout: LayoutDashboard,
                auth: true,
                role: "admin",
            });
        });
    });

    Route.group("/tools", () => {
        Route.add("dashboard_tool_all", {
            path: "/all",
            component: DashboardTools,
            //layout: LayoutDashboard,
            auth: true,
            role: "admin",
        });
        Route.add("dashboard_tool_add", {
            path: "/add-new",
            component: DashboardAddTool,
            //layout: LayoutDashboard,
            auth: true,
            role: "admin",
        });
        Route.group("/:toolId", () => {
            Route.add("dashboard_tool_edit", {
                path: "/edit",
                component: DashboardEditTool,
                //layout: LayoutDashboard,
                auth: true,
                role: "admin",
            });
        });
    });

    Route.group("/users", () => {
        Route.add("dashboard_user_all", {
            path: "/all",
            component: DashboardUsers,
            //layout: LayoutDashboard,
            auth: true,
            role: "admin",
        });
    });

    Route.add("dashboard_admin_settings", {
        path: "/settings",
        component: DashboardAdminSettings,
        //layout: LayoutDashboard,dashboard_about_edit
        auth: true,
        role: "admin",
    });

});


/* --------------------  site URL  --------------------- */

Route.add("about", {
    path: "/about",
    component: AboutPage,
});

Route.add("contact", {
    path: "/contact",
    component: ContactPage,
});


Route.add("search", {
    path: "/search/:query",
    component: Search,
});

Route.add("search1", {
    path: "/search",
    component: Search,
});

Route.add("tool", {
    path: "/tool/:id",
    component: Tool,
});

Route.homePage(HomePage);
Route.error404(NotFound);


export default Route;